import {Compound} from './Compound';
import {Simple} from './Simple';

export const Row = {
	Compound,
	Simple,
};
